(function () {
  const cartItemsElement =
    document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
  const atcItemFeatureIsEnabled = cartItemsElement?.dataset.enableConditionalAtcItem === 'true';

  if (atcItemFeatureIsEnabled && typeof window.userRemovedAutoAtcItem === 'undefined') {
    const stored = localStorage.getItem('userRemovedAutoAtcItemData');
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        const now = Date.now();
        if (parsed.value === true && parsed.expiresAt && now < parsed.expiresAt) {
          window.userRemovedAutoAtcItem = true;
        } else {
          window.userRemovedAutoAtcItem = false;
          localStorage.removeItem('userRemovedAutoAtcItemData');
        }
      } catch (err) {
        window.userRemovedAutoAtcItem = false;
        localStorage.removeItem('userRemovedAutoAtcItemData');
      }
    } else {
      window.userRemovedAutoAtcItem = false;
    }
  }
})();

class CartRemoveButton extends HTMLElement {
	constructor() {
		super();

		this.addEventListener("click", (event) => {
			event.preventDefault();

            const cartItemsElem = this.closest('cart-items') || this.closest('cart-drawer-items');
            
            if (
              cartItemsElem &&
              cartItemsElem.dataset.enableConditionalAtcItem === 'true' &&
              this.isAtcItemVariant(cartItemsElem, this.dataset.variantId)
            ) {
              window.userRemovedAutoAtcItem = true;
              const oneDayMs = 24 * 60 * 60 * 1000;
              const expiresAt = Date.now() + oneDayMs;
              const dataToStore = { value: true, expiresAt };
              localStorage.setItem('userRemovedAutoAtcItemData', JSON.stringify(dataToStore));
            }


          
			const cartItems =
				this.closest("cart-items") || this.closest("cart-drawer-items");
			cartItems.updateQuantity(this.dataset.index, 0);
		});
	}

    isAtcItemVariant(cartItemsElem, variantId) {
      const atcItemVariantsCsv = cartItemsElem.dataset.atcItemVariantToAdd || '';
      const atcItemVariantArray = atcItemVariantsCsv
        .split(',')
        .map(s => s.trim())
        .filter(Boolean);
      const isAtcItem = atcItemVariantArray.includes(String(variantId));
      return isAtcItem;
    }

}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
	constructor() {
		super();
		this.lineItemStatusElement =
			document.getElementById("shopping-cart-line-item-status") ||
			document.getElementById("CartDrawer-LineItemStatus");

		const debouncedOnChange = debounce((event) => {
			this.onChange(event);
		}, ON_CHANGE_DEBOUNCE_TIMER);

		this.addEventListener("change", debouncedOnChange.bind(this));
	}

	cartUpdateUnsubscriber = undefined;
    isForcedCartUpdate = false;

	connectedCallback() {
		this.cartUpdateUnsubscriber = subscribe(
			PUB_SUB_EVENTS.cartUpdate,
			(event) => {
				if (event.source === "cart-items") {
					return;
				}
				this.onCartUpdate();
			}
		);

      if (this.dataset.enableConditionalAtcItem === 'true' && this.tagName === 'CART-ITEMS') {
        this.checkConditionalAtcOnInitialLoad();
      }

	}

	disconnectedCallback() {
		if (this.cartUpdateUnsubscriber) {
			this.cartUpdateUnsubscriber();
		}
	}

	onChange(event) {
		this.updateQuantity(
			event.target.dataset.index,
			event.target.value,
			document.activeElement.getAttribute("name")
		);
	}

	onCartUpdate() {
if (this.tagName === 'CART-DRAWER-ITEMS') {
    fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const selectors = ['cart-drawer-items', '.cart-drawer__footer'];

        for (const selector of selectors) {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
        }
      })
      // ─────── First insertion of the conditional–ATC block ───────
      .then(() => {
        if (!this.isForcedCartUpdate && this.dataset.enableConditionalAtcItem === 'true') {
          fetch(`${routes.cart_url}.js`, { ...fetchConfig('json') })
            .then((resp) => resp.json())
            .then((cartData) => {
              const pseudoParsedState = { items: cartData.items };
              this.handleConditionalAtcItem(pseudoParsedState);
            });
        }
      })
      .catch((e) => {
        console.error(e);
      });
  } else {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceQty = html.querySelector('cart-items');
        this.innerHTML = sourceQty.innerHTML;
      })
      // ─────── Second insertion of the conditional–ATC block ───────
      .then(() => {
        if (!this.isForcedCartUpdate && this.dataset.enableConditionalAtcItem === 'true') {
          fetch(`${routes.cart_url}.js`, { ...fetchConfig('json') })
            .then((resp) => resp.json())
            .then((cartData) => {
              const pseudoParsedState = { items: cartData.items };
              this.handleConditionalAtcItem(pseudoParsedState);
            });
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

      
		// fetch(`${routes.cart_url}?section_id=main-cart-items`)
		// 	.then((response) => response.text())
		// 	.then((responseText) => {
		// 		const html = new DOMParser().parseFromString(responseText, "text/html");
		// 		const sourceQty = html.querySelector("cart-items");
		// 		this.innerHTML = sourceQty.innerHTML;
		// 	})
		// 	.catch((e) => {
		// 		console.error(e);
		// 	});









      
	}

	getSectionsToRender() {
		return [
			{
				id: "main-cart-items",
				section: document.getElementById("main-cart-items").dataset.id,
				selector: ".js-contents",
			},
			{
				id: "cart-icon-bubble",
				section: "cart-icon-bubble",
				selector: ".shopify-section",
			},
			{
				id: "cart-live-region-text",
				section: "cart-live-region-text",
				selector: ".shopify-section",
			},
			{
				id: "main-cart-footer",
				section: document.getElementById("main-cart-footer").dataset.id,
				selector: ".js-contents",
			},
		];
	}

	updateQuantity(line, quantity, name) {
        if (this.isForcedCartUpdate) {
          return;
        }

      
		this.enableLoading(line);
		this.querySelectorAll(".quantity__button").forEach((button) =>
			button.classList.add("disabled")
		);

		const body = JSON.stringify({
			line,
			quantity,
			sections: this.getSectionsToRender().map((section) => section.section),
			sections_url: window.location.pathname,
		});

		fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
			.then((response) => {
				return response.text();
			})
			.then((state) => {
				const parsedState = JSON.parse(state);
				const quantityElement =
					document.getElementById(`Quantity-${line}`) ||
					document.getElementById(`Drawer-quantity-${line}`);
				const items = document.querySelectorAll(".cart-item");
				if (parsedState.errors) {
					quantityElement.value = quantityElement.getAttribute("value");
					this.updateLiveRegions(line, parsedState.errors);
					return;
				}

				this.classList.toggle("is-empty", parsedState.item_count === 0);
				const cartDrawerWrapper = document.querySelector("cart-drawer");
				const cartFooter = document.getElementById("main-cart-footer");

				if (cartFooter)
					cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
				if (cartDrawerWrapper)
					cartDrawerWrapper.classList.toggle(
						"is-empty",
						parsedState.item_count === 0
					);

				this.getSectionsToRender().forEach((section) => {
					const elementToReplace =
						document
							.getElementById(section.id)
							.querySelector(section.selector) ||
						document.getElementById(section.id);
					elementToReplace.innerHTML = this.getSectionInnerHTML(
						parsedState.sections[section.section],
						section.selector
					);
				});
				const updatedValue = parsedState.items[line - 1]
					? parsedState.items[line - 1].quantity
					: undefined;
				let message = "";
				if (
					items.length === parsedState.items.length &&
					updatedValue !== parseInt(quantityElement.value)
				) {
					if (typeof updatedValue === "undefined") {
						message = window.cartStrings.error;
					} else {
						message = window.cartStrings.quantityError.replace(
							"[quantity]",
							updatedValue
						);
					}
				}
				this.updateLiveRegions(line, message);

				const lineItem =
					document.getElementById(`CartItem-${line}`) ||
					document.getElementById(`CartDrawer-Item-${line}`);
				if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
					cartDrawerWrapper
						? trapFocus(
								cartDrawerWrapper,
								lineItem.querySelector(`[name="${name}"]`)
						  )
						: lineItem.querySelector(`[name="${name}"]`).focus();
				} else if (parsedState.item_count === 0 && cartDrawerWrapper) {
					trapFocus(
						cartDrawerWrapper.querySelector(".drawer__inner-empty"),
						cartDrawerWrapper.querySelector("a")
					);
				} else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
					trapFocus(
						cartDrawerWrapper,
						document.querySelector(".cart-item__name")
					);
				}
				publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items" });

                const { enableConditionalAtcItem } = this.getConditionalAtcItemSettings();

                if (enableConditionalAtcItem) {
                  clearTimeout(this._giftSyncTimeout);
                  this._giftSyncTimeout = setTimeout(() => {
                    this.isForcedCartUpdate = false; // Allow gift logic to run again
                    fetch(`${routes.cart_url}.js`, {
                      method: 'GET',
                      headers: { 'Content-Type': 'application/json' }
                    })
                      .then((resp) => resp.json())
                      .then((cartData) => {
                        const pseudoParsedState = { items: cartData.items };
                        this.handleConditionalAtcItem(pseudoParsedState);
                      });
                  }, 300);
                }





              
			})
			.catch(() => {
				this.querySelectorAll(".loading-overlay").forEach((overlay) =>
					overlay.classList.add("hidden")
				);
				this.querySelectorAll(".quantity__button").forEach((button) =>
					button.classList.remove("disabled")
				);
				const errors =
					document.getElementById("cart-errors") ||
					document.getElementById("CartDrawer-CartErrors");
				errors.textContent = window.cartStrings.error;
			})
			.finally(() => {
				this.querySelectorAll(".quantity__button").forEach((button) =>
					button.classList.remove("disabled")
				);
				this.disableLoading(line);
			});
	}

	updateLiveRegions(line, message) {
		const lineItemError =
			document.getElementById(`Line-item-error-${line}`) ||
			document.getElementById(`CartDrawer-LineItemError-${line}`);
		if (lineItemError)
			lineItemError.querySelector(".cart-item__error-text").innerHTML = message;

		this.lineItemStatusElement.setAttribute("aria-hidden", true);

		const cartStatus =
			document.getElementById("cart-live-region-text") ||
			document.getElementById("CartDrawer-LiveRegionText");
		cartStatus.setAttribute("aria-hidden", false);

		setTimeout(() => {
			cartStatus.setAttribute("aria-hidden", true);
		}, 1000);
	}

	getSectionInnerHTML(html, selector) {
		return new DOMParser()
			.parseFromString(html, "text/html")
			.querySelector(selector).innerHTML;
	}

	enableLoading(line) {
		const mainCartItems =
			document.getElementById("main-cart-items") ||
			document.getElementById("CartDrawer-CartItems");
		mainCartItems.classList.add("cart__items--disabled");

		const cartItemElements = this.querySelectorAll(
			`#CartItem-${line} .loading-overlay`
		);
		const cartDrawerItemElements = this.querySelectorAll(
			`#CartDrawer-Item-${line} .loading-overlay`
		);

		[...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
			overlay.classList.remove("hidden")
		);

		document.activeElement.blur();
		this.lineItemStatusElement.setAttribute("aria-hidden", false);
	}

	disableLoading(line) {
		const mainCartItems =
			document.getElementById("main-cart-items") ||
			document.getElementById("CartDrawer-CartItems");
		mainCartItems.classList.remove("cart__items--disabled");

		const cartItemElements = this.querySelectorAll(
			`#CartItem-${line} .loading-overlay`
		);
		const cartDrawerItemElements = this.querySelectorAll(
			`#CartDrawer-Item-${line} .loading-overlay`
		);

		cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
		cartDrawerItemElements.forEach((overlay) =>
			overlay.classList.add("hidden")
		);
	}

  getConditionalAtcItemSettings() {
    const enableConditionalAtcItem = this.dataset.enableConditionalAtcItem === 'true';
    const atcItemConditionType = this.dataset.atcItemConditionType || '';
    const atcItemMetaobjectHandle = this.dataset.atcItemMetaobjectHandle || '';
    const atcItemProductListCsv = this.dataset.atcItemProductList || '';
    const useAsExclusion = (this.dataset.atcItemUseAsExclusion === 'true');
    const atcItemThresholdValue = parseFloat(this.dataset.atcItemThresholdValue || '0');

    const parseCsv = (csv) => {
      return csv
        .split(',')
        .map((s) => s.trim())
        .filter((s) => s.length > 0);
    };

    const atcItemVariantToAddCsv = this.dataset.atcItemVariantToAdd || '';
    const atcItemVariantToAdd = parseCsv(atcItemVariantToAddCsv);
    const atcItemProductList = parseCsv(atcItemProductListCsv);

    return {
      enableConditionalAtcItem,
      atcItemConditionType,
      atcItemMetaobjectHandle,
      atcItemProductList,
      useAsExclusion,
      atcItemVariantToAdd,
      atcItemThresholdValue
    };
  }

  checkConditionalAtcOnInitialLoad() {
    fetch(`${routes.cart_url}.js`, { ...fetchConfig('json') })
      .then((resp) => resp.json())
      .then((cartData) => {
        const pseudoParsedState = {
          items: cartData.items
        };
        this.handleConditionalAtcItem(pseudoParsedState);
      })
      .catch((err) => {});
  }

  handleConditionalAtcItem(parsedState) {
    if (this.isForcedCartUpdate) {
      return;
    }

    const {
      enableConditionalAtcItem,
      atcItemConditionType,
      atcItemProductList,
      useAsExclusion,
      atcItemVariantToAdd,
      atcItemThresholdValue
    } = this.getConditionalAtcItemSettings();

    if (!enableConditionalAtcItem) {
      return;
    }

    let relevantCount = 0;
    let relevantTotal = 0;

    parsedState.items.forEach((item) => {
      if (atcItemVariantToAdd.includes(String(item.variant_id))) {
        return;
      }
      const productIdStr = String(item.product_id);
      let productEligible;

      if (atcItemProductList.length === 0) {
        productEligible = true;
      } else if (useAsExclusion) {
        productEligible = !atcItemProductList.includes(productIdStr);
      } else {
        productEligible = atcItemProductList.includes(productIdStr);
      }

      if (!productEligible) return;

      if (atcItemConditionType === 'cart_item_count') {
        relevantCount += item.quantity;
      } else if (atcItemConditionType === 'cart_subtotal') {
        relevantTotal += item.original_line_price;
      } else if (atcItemConditionType === 'cart_total') {
        relevantTotal += item.final_line_price;
      }
    });

    let conditionMet = false;
    if (atcItemConditionType === 'cart_item_count') {
      conditionMet = relevantCount >= atcItemThresholdValue;
    } else {
      const requiredCents = atcItemThresholdValue * 100;
      conditionMet = relevantTotal >= requiredCents;
    }

    if (!conditionMet) {
      window.userRemovedAutoAtcItem = false;
      localStorage.removeItem('userRemovedAutoAtcItemData');
    }

    if (conditionMet && window.userRemovedAutoAtcItem) {
      return;
    }

    const singleVariantId = atcItemVariantToAdd[0];
    if (!singleVariantId) {
      return;
    }
    const lineIndex = this.findLineIndexByVariantId(parsedState.items, singleVariantId);

      //   if (conditionMet) {
      //   const desiredGiftQty = relevantCount;
      //   const giftItem = parsedState.items.find(
      //     (it) => String(it.variant_id) === String(singleVariantId)
      //   );
      //   const currentGiftQty = giftItem ? giftItem.quantity : 0;
      
      //   if (currentGiftQty !== desiredGiftQty) {
      //     this.isForcedCartUpdate = true;
      
      //     // Gift not in cart → Add it
      //     if (!giftItem) {
      //       const body = JSON.stringify({
      //         items: [{ id: singleVariantId, quantity: desiredGiftQty }]
      //       });
      
      //       fetch(`${routes.cart_add_url}`, {
      //         method: 'POST',
      //         headers: { 'Content-Type': 'application/json' },
      //         body
      //       })
      //         .then((res) => res.json())
      //         .then(() => {
      //           setTimeout(() => {
      //             this.refreshCartAfterForcedUpdate();
      //           }, 250);
      //         })
      //         .catch(() => {
      //           this.isForcedCartUpdate = false;
      //         });
      //     } else {
      //       // Gift is already in cart → update using line number
      //       const giftLineIndex = parsedState.items.findIndex(
      //         (it) => String(it.variant_id) === String(singleVariantId)
      //       );
      
      //       const body = JSON.stringify({
      //         line: giftLineIndex + 1, // Shopify line numbers are 1-based
      //         quantity: desiredGiftQty
      //       });
      
      //       fetch(`${routes.cart_change_url}`, {
      //         method: 'POST',
      //         headers: { 'Content-Type': 'application/json' },
      //         body
      //       })
      //         .then((res) => res.json())
      //         .then(() => {
      //           setTimeout(() => {
      //             this.refreshCartAfterForcedUpdate();
      //           }, 250);
      //         })
      //         .catch(() => {
      //           this.isForcedCartUpdate = false;
      //         });
      //     }
      //   }
      // } else {
      //   if (lineIndex !== -1) {
      //     this.forceCartRemove(lineIndex + 1);
      //   }
      // }
    
      if (conditionMet) {
        const giftQty = relevantCount;
        const giftVariantId = singleVariantId;
      
        fetch(`${routes.cart_url}.js`)
          .then((res) => res.json())
          .then((cart) => {
            const giftLineItems = cart.items.filter(
              (item) => String(item.variant_id) === String(giftVariantId)
            );
      
            const currentGiftQty = giftLineItems.reduce((sum, item) => sum + item.quantity, 0);
            const delta = giftQty - currentGiftQty;
      
            if (delta === 0) return;
      
            if (giftLineItems.length === 0) {
              this.forceCartAdd(giftVariantId, giftQty);
            } else {
              const firstLineIndex = giftLineItems[0].key;
              fetch(`${routes.cart_change_url}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  id: firstLineIndex,
                  quantity: giftLineItems[0].quantity + delta
                })
              })
                .then(() => {
                  this.refreshCartAfterForcedUpdate();
                })
                .catch(() => {
                  this.isForcedCartUpdate = false;
                });
            }
          });
      } else {
        if (lineIndex !== -1) {
          this.forceCartRemove(lineIndex + 1);
        }
      }







    
  }

  findLineIndexByVariantId(items, variantId) {
    return items.findIndex((it) => String(it.variant_id) === String(variantId));
  }

  forceCartAdd(variantId, quantity) {
    this.isForcedCartUpdate = true;

    const body = JSON.stringify({
      items: [{ id: variantId, quantity }]
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('json'), ...{ body } })
      .then((response) => response.json())
      .then((jsonData) => {
        this.refreshCartAfterForcedUpdate();
      })
      .catch((err) => {
        this.isForcedCartUpdate = false;
      });
  }

  forceCartRemove(line) {
    this.isForcedCartUpdate = true;

    const body = JSON.stringify({
      line,
      quantity: 0
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.text())
      .then((state) => {
        this.refreshCartAfterForcedUpdate();
      })
      .catch((err) => {
        this.isForcedCartUpdate = false;
      });
  }

  refreshCartAfterForcedUpdate() {
    const isDrawer = (this.tagName === 'CART-DRAWER-ITEMS');
    const sectionId = isDrawer ? 'cart-drawer' : 'main-cart-items';

    fetch(`${routes.cart_url}?section_id=${sectionId}`)
      .then((resp) => resp.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');

        if (isDrawer) {
          const newDrawerItems = html.querySelector('cart-drawer-items');
          const newDrawerFooter = html.querySelector('.cart-drawer__footer');
          const currentDrawerItems = document.querySelector('cart-drawer-items');
          const currentDrawerFooter = document.querySelector('.cart-drawer__footer');
          if (newDrawerItems && currentDrawerItems) {
            currentDrawerItems.replaceWith(newDrawerItems);
          }
          if (newDrawerFooter && currentDrawerFooter) {
            currentDrawerFooter.replaceWith(newDrawerFooter);
          }
        } else {
          const newCartItems = html.querySelector('cart-items');
          if (newCartItems) {
            this.innerHTML = newCartItems.innerHTML;
          }
        }
      })
      .catch((err) => {})
      .finally(() => {
        setTimeout(() => {
          this.isForcedCartUpdate = false;
        }, 150); // Let DOM settle before re-enabling gift sync

        if (isDrawer) {
            const newDrawerItems = document.querySelector('cart-drawer-items');
            if (newDrawerItems && typeof newDrawerItems.connectedCallback === 'function') {
              newDrawerItems.connectedCallback(); // Re-run logic
            }
          } else {
            const newCartItems = document.querySelector('cart-items');
            if (newCartItems && typeof newCartItems.connectedCallback === 'function') {
              newCartItems.connectedCallback(); // Re-run logic
            }
          }


        
      }
              );

  }

}

customElements.define("cart-items", CartItems);


if (!customElements.get("cart-note")) {
	customElements.define(
		"cart-note",
		class CartNote extends HTMLElement {
			constructor() {
				super();

				this.addEventListener(
					"change",
					debounce((event) => {
						const body = JSON.stringify({ note: event.target.value });
						fetch(`${routes.cart_update_url}`, {
							...fetchConfig(),
							...{ body },
						});
					}, ON_CHANGE_DEBOUNCE_TIMER)
				);
			}
		}
	);
}
